// extracted by mini-css-extract-plugin
export default {"tab":"OrderTabs_tab__3oOlF","border-wrapper":"OrderTabs_border-wrapper__x5yI9","active":"OrderTabs_active__nS-Rk"};